import {UPDATEROW} from '../constants'
import axiosInstance from "../utils/axios.interceptor";
import utils from '../utils';
export const Updateclinicentry = (clinicname,BillNo,TotalOutstanding,OutstandingDoctorAllocation,OutstandingHospital,Comments,Reviewed,Reviewstatus,ReviewedAt,DoctorDisallowedAmount,icdcode,scaleofcost,_login) => {
  return async (dispatch) => {

    let timestamp = utils.getTimeStamp();
    let response = await axiosInstance({
      method: 'POST',
      url: '/updateclinicentry',
      data: {"clinicname": clinicname,"BillNo":BillNo,"TotalOutstanding":TotalOutstanding,"OutstandingDoctorAllocation":OutstandingDoctorAllocation,
      "OutstandingHospital":OutstandingHospital,"Comments":Comments,"Reviewed":Reviewed,"Reviewstatus":Reviewstatus,"ReviewedAt":ReviewedAt,
        "DoctorDisallowedAmount":DoctorDisallowedAmount,"icdcode":icdcode,"scaleofcost":scaleofcost,"swanuser":_login,"timestamp":timestamp}
    });
    //This is to trigger componentWillReceiveProps()
    response.timestamp = new Date().toLocaleString();
      dispatch({type:UPDATEROW,payload:response.data});
  };
};


export const UpdatePCLentry = (clinicname,BillNo,PCLPROCESSING,PCLUSER,PCLTIMESTAMP,PCLCOMMENTS) => {
  return async (dispatch) => {

    let response = await axiosInstance({
      method: 'POST',
      url: '/updatepclentry',
      data: {"clinicname": clinicname,"BillNo":BillNo,"PCLPROCESSING":PCLPROCESSING,"PCLUSER":PCLUSER, "PCLTIMESTAMP":PCLTIMESTAMP, "PCLCOMMENTS":PCLCOMMENTS}
    });
    //This is to trigger componentWillReceiveProps()
    response.timestamp = new Date().toLocaleString();
    dispatch({type:UPDATEROW,payload:Object.values(response.data)});
  };
};
